export const GET_ALL_PROJECTS_REQUEST = 'GET_ALL_PROJECTS_REQUEST'
export const GET_ALL_PROJECTS_SUCCESS = 'GET_ALL_PROJECTS_SUCCESS'
export const GET_ALL_PROJECTS_FAIL = 'GET_ALL_PROJECTS_FAIL'
export const GET_ALL_PROJECTS_RESET = 'GET_ALL_PROJECTS_RESET'

export const CREATE_PROJECT_REQUEST = 'CREATE_PROJECT_REQUEST'
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS'
export const CREATE_PROJECT_FAIL = 'CREATE_PROJECT_FAIL'
export const CREATE_PROJECT_RESET = 'CREATE_PROJECT_RESET'

export const GET_RECENT_FILES_REQUEST = 'GET_RECENT_FILES_REQUEST'
export const GET_RECENT_FILES_SUCCESS = 'GET_RECENT_FILES_SUCCESS'
export const GET_RECENT_FILES_FAIL = 'GET_RECENT_FILES_FAIL'
export const GET_RECENT_FILES_RESET = 'GET_RECENT_FILES_RESET'

export const GET_BOOKMARK_FILES_REQUEST = 'GET_BOOKMARK_FILES_REQUEST'
export const GET_BOOKMARK_FILES_SUCCESS = 'GET_BOOKMARK_FILES_SUCCESS'
export const GET_BOOKMARK_FILES_FAIL = 'GET_BOOKMARK_FILES_FAIL'
export const GET_BOOKMARK_FILES_RESET = 'GET_BOOKMARK_FILES_RESET'

export const GET_FILES_REQUEST = 'GET_FILES_REQUEST'
export const GET_FILES_SUCCESS = 'GET_FILES_SUCCESS'
export const GET_FILES_FAIL = 'GET_FILES_FAIL'
export const GET_FILES_RESET = 'GET_FILES_RESET'

export const CREATE_FILE_REQUEST = 'CREATE_FILE_REQUEST'
export const CREATE_FILE_SUCCESS = 'CREATE_FILE_SUCCESS'
export const CREATE_FILE_FAIL = 'CREATE_FILE_FAIL'
export const CREATE_FILE_RESET = 'CREATE_FILE_RESET'

export const EDIT_FILE_REQUEST = 'EDIT_FILE_REQUEST'
export const EDIT_FILE_SUCCESS = 'EDIT_FILE_SUCCESS'
export const EDIT_FILE_FAIL = 'EDIT_FILE_FAIL'
export const EDIT_FILE_RESET = 'EDIT_FILE_RESET'

export const DELETE_FILE_REQUEST = 'DELETE_FILE_REQUEST'
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS'
export const DELETE_FILE_FAIL = 'DELETE_FILE_FAIL'
export const DELETE_FILE_RESET = 'DELETE_FILE_RESET'

export const RENAME_FILE_REQUEST = 'RENAME_FILE_REQUEST'
export const RENAME_FILE_SUCCESS = 'RENAME_FILE_SUCCESS'
export const RENAME_FILE_FAIL = 'RENAME_FILE_FAIL'
export const RENAME_FILE_RESET = 'RENAME_FILE_RESET'

export const DUPLICATE_FILE_REQUEST = 'DUPLICATE_FILE_REQUEST'
export const DUPLICATE_FILE_SUCCESS = 'DUPLICATE_FILE_SUCCESS'
export const DUPLICATE_FILE_FAIL = 'DUPLICATE_FILE_FAIL'
export const DUPLICATE_FILE_RESET = 'DUPLICATE_FILE_RESET'

export const MOVE_FILE_REQUEST = 'MOVE_FILE_REQUEST'
export const MOVE_FILE_SUCCESS = 'MOVE_FILE_SUCCESS'
export const MOVE_FILE_FAIL = 'MOVE_FILE_FAIL'
export const MOVE_FILE_RESET = 'MOVE_FILE_RESET'

export const RENAME_FOLDER_REQUEST = 'RENAME_FOLDER_REQUEST'
export const RENAME_FOLDER_SUCCESS = 'RENAME_FOLDER_SUCCESS'
export const RENAME_FOLDER_FAIL = 'RENAME_FOLDER_FAIL'
export const RENAME_FOLDER_RESET = 'RENAME_FOLDER_RESET'

